import { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { IpageSearch } from './image-popup';
import { ICheckoutPage } from '../../interface/pageInterface';
import { IAsset } from '../../interface/apiServiceInterface';
import {
  showNotification,
  StatusCode,
  toasterMessage,
} from '../../api/constant';
import checkoutService from '../../api/checkoutService';

type ImageProps = {
  setImageList: React.Dispatch<React.SetStateAction<IAsset[]>>;
  setDefaultImageList: React.Dispatch<React.SetStateAction<IAsset[]>>;
  setPagesSearch: React.Dispatch<React.SetStateAction<IpageSearch>>;
  checkoutPage: ICheckoutPage | null;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ImageInput = ({
  setImageList,
  setDefaultImageList,
  setPagesSearch,
  checkoutPage,
  setLoading,
}: ImageProps) => {
  const [, setFiles] = useState<File[]>([]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/jpeg': ['.jpeg', '.jpg'],
      'image/png': ['.png'],
      'image/webp': ['.webp'],
    },
    onDropRejected: fileRejections => {
      fileRejections.forEach(({ file, errors }) => {
        errors.forEach(({ code }) => {
          let errorMessage;
          switch (code) {
            case 'file-invalid-type':
              errorMessage =
                'Invalid format. Only JPEG, PNG, and WEBP files are allowed.';
              break;
            default:
              errorMessage = 'File not accepted.';
          }
          showNotification(
            StatusCode.failed,
            `File: ${file.name} - ${errorMessage}`,
          );
        });
      });
    },
    onDrop: async acceptedFiles => {
      try {
        setFiles(acceptedFiles);
        if (acceptedFiles.length) {
          const files: FormData[] = [];
          for (const file of acceptedFiles) {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('name', file.name);
            formData.append('filename', file.name);
            formData.append('store_id', checkoutPage?.StoreID || '');
            files.push(formData);
          }
          setLoading(true);
          const response = await checkoutService.createAsset(files);
          setLoading(false);
          if (response.status === 200) {
            showNotification(
              StatusCode.success,
              toasterMessage.imageUploadSuccess,
            );
            setImageList([]);
            setDefaultImageList([]);
            setPagesSearch(prevPage => ({
              ...prevPage,
              Page: 0,
            }));
          }
        }
      } catch (error) {
        setLoading(false);
        console.error('ERROR IN onDropAccepted', error);
      }
    },
  });
  return (
    <section className="container flex justify-center">
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <p className="pl-6">Upload Image</p>
        <p>Drag and drop images</p>
      </div>
    </section>
  );
};
